import {
  FaceBookIcon,
  TwitterIcon,
  YouTubeIcon,
  DonationIcon,
} from "../components/common/icons/Icons";

// NAVBAR USE LINKS
export const linksList = [
  {
    to: "/",
    title: "Home",
  },
  // {
  //   to: "/courses",
  //   title: "Yoga Program",
  // },
  {
    to: "#",
    title: "Who We Are",
    submenu: [
      {
        to: "/poojya-shri-punitachariji-maharaj",
        title: "Poojya Shree Punitachariji Maharaj"
      },
      {
        to: "/poojya-Maiyashree-shailja-devi",
        title: "Poojya Maiyashree ShailajaDevi"
      },
      {
        to: "/hari-om-tatsat-jai-guru-datta",
        title: "Maha Mantra"
      }
    ]
  },
  {
    to: "#",
    title: "Our Ashrams",
    submenu: [
      {
        to: "/girnar-sadhna-ashram",
        title: "Girnar Sadhna Ashram"
      },
      {
        to: "/trimurti-seva-ashram-rishikesh",
        title: "Trimurti Seva Ashram"
      },
    ]
  },
  {
    to: "/contact",
    title: "Contact",
  },
  
];

// SOCIAL LINKS ADD IN NAVBAR
export const socialLinksList = [
  {
    to: "https://www.facebook.com/dattsahajyoga/",
    title: (circleFill = "#E97219", pathFill="white") => <FaceBookIcon circleFill={circleFill} pathFill={pathFill} />,
  },
  {
    to: "https://www.youtube.com/c/GirnarSadhanaAshram",
    title: (circleFill = "#E97219", pathFill="white") => <YouTubeIcon circleFill={circleFill} pathFill={pathFill} />,
  },
  {
    to: "https://x.com/dattsahajyoga",
    title: (circleFill = "#E97219", pathFill="white") => <TwitterIcon circleFill={circleFill} pathFill={pathFill} />,
  },
  {
    to: "https://donation.dattadham.org/",
    title: (circleFill = "#E97219", pathFill="white") => <DonationIcon circleFill={circleFill} pathFill={pathFill} />,
  }
];

